import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TimeBreakInfoPopup extends Component {
  static propTypes = {
    workerStartTime: PropTypes.string.isRequired,
    workerEndTime: PropTypes.string.isRequired,
    workerBreak: PropTypes.string
  };

  render () {
    const { workerStartTime, workerEndTime, workerBreak } = this.props;
    return (
      <div className='popupMenu'>
        <header className='px-3 py-2'>Hours</header>
        <p className='px-3 py-2'>Start time: { workerStartTime }</p>
        <p className='px-3 py-2'>End time: { workerEndTime }</p>
        { workerBreak && <p className='px-3 py-2'>Break: { workerBreak }</p> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/WorkersTab/TimeBreakInfoPopup.js